import { render, staticRenderFns } from "./DmButton.vue?vue&type=template&id=f578afc2&"
import script from "./DmButton.vue?vue&type=script&lang=js&"
export * from "./DmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports